import { useState } from "react";
import { config } from "../../config";
import AnswerPair from "../answerpair/answerpair";
import ResultCard from "../resultcard/resultcard";
import Timer from "../timer/timer";
import "./situation.css";

function SituationCard({ data, onComplete, gameData }) {
  const [showCards, setShowCards] = useState(false);
  const [showResult, setShowResult] = useState(0); //correct answer in args

  const reset = () => {
    setShowCards(false);
    setShowResult(0);
  };

  const onNext = () => {
    document.getElementById("situation-card-id").classList.add("collapse");
    setTimeout(() => {
      setShowCards(true);
    }, 500);
  };
  if (showResult) {
    return (
      <ResultCard
        onNext={() => {
          document.getElementById("result-card").classList.add("collapse");

          setTimeout(() => {
            reset();
            onComplete(
              showResult === data.situation.correct && showResult !== 3
            );
          }, 500);
        }}
        gameData={gameData}
        correct={showResult}
        situation={data.situation}
      />
    );
  }

  if (showCards) {
    return (
      <AnswerPair
        gameData={gameData}
        situation={data.situation}
        answered={(correct) => {
          setTimeout(() => {
            setShowResult(correct);
          }, 500);
        }}
      />
    );
  }

  return (
    <>
      <Timer
        duration={
          gameData.config?.situation_duration ||
          config.situationDuration
        }
        onDone={() => onNext()}
      />
      <div
        className="situation-container"
        id="situation-card-id"
        onClick={() => onNext()}
      >
        <b>
          Situation: {data.round} / {gameData.data.length}
        </b>
        <br />
        <br />
        {data.situation.question}
        <br />
        <br />
        <span style={{ color: "grey" }}>Tap to see options</span>
      </div>
    </>
  );
}

export default SituationCard;
